import React from 'react';
import { NewAddonProvider } from 'contexts/new-addon.context';
import NewAddonContent from './content';

const NewAddonLayout = () => {
  return (
    <NewAddonProvider>
      <NewAddonContent />
    </NewAddonProvider>
  );
};

export default NewAddonLayout;
